import { jsonBody, requestJson } from "../http/httpClient";
import { readNullableString, readObject, readString } from "../http/jsonDecoding";

/**
 * A change set's rebuild of the items it keeps up to date, a Run of module C (ADR-0044): the
 * caller's PC takes it over, or the change set first takes what landed on main.
 * Routes: `server/src/dmw/api/routes/threads/maintained_rebuilds.py`.
 */
export interface MaintainedRebuild {
  readonly head: string;
  /** The Run it runs in; null until it starts on its host's PC, or when nothing waits for it. */
  readonly threadId: string | null;
}

const rebuildPath = (changeSetId: string): `/${string}` =>
  `/change-sets/${encodeURIComponent(changeSetId)}/maintained-rebuild`;

function decodeRebuild(body: unknown): MaintainedRebuild {
  const rebuild = readObject(body, "maintained rebuild");
  return { head: readString(rebuild, "head"), threadId: readNullableString(rebuild, "thread_id") };
}

/** "Rebuild on my PC": the caller's PC runs the rebuild from now on. */
export function rebuildOnMyPc(changeSetId: string): Promise<MaintainedRebuild> {
  return requestJson({ method: "POST", path: `${rebuildPath(changeSetId)}/host`, decodeResponse: decodeRebuild });
}

/** "Update from main", on the head the caller saw; the rebuild then runs at the new head. */
export function updateFromMain(changeSetId: string, expectedHead: string): Promise<MaintainedRebuild> {
  return requestJson({
    method: "POST",
    path: `${rebuildPath(changeSetId)}/update-from-main`,
    body: jsonBody({ expected_head: expectedHead }),
    decodeResponse: decodeRebuild,
  });
}
